module.exports = __webpack_public_path__ + "img/footer_icon1.83cb7753.png";